import { SYSTEM_MESSAGES } from "@/messages/System";

export default {
   name: "Input Helper Mixins",
   data() {
      return {
         maxLengthInput: 140,
         regex: null,
         stringInput: "",
         indexChatInput: 0,
         remainingTimeToastrShow: 0,
         intervalToastShowId: null
      };
   },
   created() {},
   methods: {
      keyDownPress(e) {
         if (e.keyCode == 13 && !e.shiftKey) {
            // Enter key
            e.preventDefault();
            this.enterPressed();
         }
         let ctrlKey = 17,
            cmdKey = 91,
            vKey = 86,
            cKey = 67,
            xKey = 88,
            aKey = 65;

         let keyCode = e.keyCode || e.which;

         // Detect when user press Ctrl C or Ctrl V:
         if (keyCode == ctrlKey || keyCode == cmdKey) this.ctrlDown = true;
         if (this.ctrlDown && (keyCode == vKey || keyCode == cKey || keyCode == xKey || keyCode == aKey)) {
            // navigator.clipboard.readText().then(text => alert(text));
            return;
         }

         // Don't validate the input if below arrow, delete and backspace keys were pressed
         if (keyCode != 37 && keyCode != 38 && keyCode != 39 && keyCode != 40 && keyCode != 46 && keyCode != 8 && keyCode != 9) {
            // Left / Up / Right / Down Arrow, Delete/ tab keys;
            let stringInput = this.stringInput;
            if (e.target.selectionEnd == e.target.selectionStart && this.maxLengthInput <= stringInput.length) {
               e.preventDefault();
               /*
                * Show warning if exceed max length
                */
               this.showToastLimitChar();
               return false;
            }

            let keyCharacter = e.key;
            let pattern = new RegExp(this.regex);
            if (this.regex !== undefined && this.regex !== null && this.regex !== "") {
               let res = pattern.test(keyCharacter);
               if (!res) {
                  e.preventDefault();
                  return false;
               }
            }
         }
         if (keyCode === 8) {
            let stringTmp = this.stringInput;
            let cursorPositionStart = this.getPositionCursorInString(stringTmp, e.target.selectionStart);
            if (cursorPositionStart > 0) {
               if (e.target.selectionEnd == e.target.selectionStart) {
                  e.preventDefault();
                  this.stringInput = this.removeCharacter(stringTmp, cursorPositionStart - 1);
               }
            }
         }
      },
      keyUpPress(e) {
         let ctrlKey = 17,
            cmdKey = 91;
         let keyCode = e.keyCode || e.which;
         if (keyCode == ctrlKey || keyCode == cmdKey) this.ctrlDown = false;
      },
      getPositionCursorInString(str, currentCursorPosition) {
         let partSliceString = str.slice(0, currentCursorPosition); // Get part string after slice from cursor => partSliceString = (0123
         return currentCursorPosition - partSliceString.length; // Get the position of cursor in string number => result = 3
      },
      removeCharacter(str, char_pos) {
         let part1 = str.substring(0, char_pos);
         let part2 = str.substring(char_pos + 1, str.length);
         return part1 + part2;
      },
      enterPressed: function() {},
      clearIntervalToastShow: function() {
         clearInterval(this.intervalToastShowId);
         this.intervalToastShowId = null;
         this.remainingTimeToastrShow = 0;
      },
      updateInput: function(val) {
         /*
          * Show warning if exceed max length
          */
         if (this.maxLengthInput < val.length) {
            this.showToastLimitChar();
            // Trigger a DOM 'input' event
            this.stringInput = val.substring(0, this.maxLengthInput);
            this.indexChatInput++;
         }
      },
      showToastLimitChar: function() {
         if (!this.remainingTimeToastrShow) {
            this.remainingTimeToastrShow = 5;
            this.$root.$emit("showToast", SYSTEM_MESSAGES.MAX_LENGTH_CHAT);
            this.intervalToastShowId = setInterval(() => {
               this.remainingTimeToastrShow--;
               if (!this.remainingTimeToastrShow) {
                  this.clearIntervalToastShow();
               }
            }, 1000);
         }
      }
   }
};
